import Base from './Base.vue'
import Overview from './Overview'


export default{
    Base,
    Overview
}


// WEBPACK FOOTER //
// ./src/views/customer/ourBrands/index.js